export const PUSH_SERVER_APNS = 0
export const PUSH_SERVER_FIREBASE = 1
